/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.enterAnimation = function () {
    let $loader = $('.c-loader');


    if (!$loader.length === 0) {
      return false;
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.addClass(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function () {
      // ここから実行
      if ($loader) {
        changeClass($loader, "is-active", 1000).then(function () {
          changeClass($loader, "is-close", 2000).then(function () {
            changeClass($loader, "is-hidden", 1000).then(function () {

            });
          });
        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      // テストはこちらをコメントアウト外す
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      $loader.addClass('is-already');
    }


  };

  growApp.prototype.backCache = function () {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    }
  }

  growApp.prototype.scrollBg = function () {
    // headerの高さを取得、resize()はスマホ時で高さが変動するので使用
    let $headerHeight = $(".l-header").resize().height();
    let $target = $(".c-block-story");

    if ($target.length === 0) {
      return false;
    }

    $(window).scroll(function () {
      let $windowTop = $(window).scrollTop() + $headerHeight;
      let $targetOffset = $target.offset().top;

      //スクロール位置がnavの位置より下だったらクラスfixedを追加
      if ($windowTop >= $targetOffset) {
        $target.addClass('is-fixed');
      } else {
        $target.removeClass('is-fixed');
      }
    });
  }

  growApp.prototype.clickAlert = function () {
    $('.js-click-alert').on('click mouseend touchend', function () {
      let $url = $(this).data('url');
      if (!$url) {
        return false;
      }

      let ok = confirm('外部サイトへリンクしますがよろしいでしょうか。');
      if (ok) {
        window.open($url, '_blank');
      } else {
        return false;
      }
    });
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.enterAnimation();
    app.scrollBg();
    app.clickAlert();
  });
})(jQuery);
